import React from 'react';

const CareersHeroVector = ({ ...props }) => (
  <svg
    width="366"
    height="401"
    viewBox="0 0 366 401"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M366 334.919C366 338.873 365.219 342.788 363.702 346.441C362.185 350.093 359.961 353.412 357.158 356.208C354.355 359.004 351.027 361.221 347.365 362.734C343.702 364.247 339.777 365.026 335.812 365.026H327.88V393.473C327.88 395.469 327.085 397.384 325.67 398.795C324.254 400.207 322.335 401 320.333 401H49.6019C47.6003 401 45.6807 400.207 44.2654 398.795C42.8501 397.384 42.055 395.469 42.055 393.473V365.026H30.1875C22.1813 365.026 14.503 361.854 8.8417 356.208C3.18044 350.562 0 342.904 0 334.919V112.902C0 82.9587 11.9267 54.2416 33.1565 33.0683C54.3862 11.895 83.1799 0 113.203 0H252.797C282.82 0 311.614 11.895 332.844 33.0683C354.073 54.2416 366 82.9587 366 112.902V334.919Z"
      fill="#941535"
    />
  </svg>
);

export default CareersHeroVector;
